module.exports = __webpack_public_path__ + "static/img/Kiitoskortti_Avecor_markku-nuutinen_A4.482b865.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/salesperson-leaflets/Kiitoskortti_Avecor_markku-nuutinen_A4.pdf
// module id = fQgI
// module chunks = 22